import { chakra, Flex, Text } from "@chakra-ui/react"
import { colors } from "lib/theme"
import { colours } from "@shared/ui.design-system"

export const OuterContainer = chakra(Flex, {
  baseStyle: {
    w: "100%",
    maxW: "90rem",
    py: {
      base: "2.5rem",
      lg: "5rem",
    },
    position: "relative",
    backgroundColor: colours.secondary.warm,
    flexDirection: "column",
  },
})

export const InnerContainer = chakra(Flex, {
  baseStyle: {
    flexDirection: "column",
    m: "0 auto",
    w: "100%",
    maxW: "90rem",
  },
})

export const Headline = chakra(Text, {
  baseStyle: {
    fontSize: { base: "1.25rem", lg: "1.75rem" },
    lineHeight: { base: "1.75rem", lg: "2.25rem" },
    mt: "0",
    fontFeatureSettings: "'case' on, 'cpsp' on, 'liga' off",
  },
  shouldForwardProp: () => true,
})

export const ProductsContainer = chakra(Flex, {
  baseStyle: {
    flexDirection: "column",
    gap: { base: "1.25rem", md: "2.5rem" },
    overflowX: { base: "auto", xl: "hidden" },
    position: "relative",
    pb: { base: "1.25rem", md: "2.5rem" },
    px: {
      base: "1.5rem",
      md: "5rem",
      lg: "7.5rem",
    },
  },
})

export const ShopLinkText = chakra(Text, {
  baseStyle: {
    mt: 0,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    whiteSpace: "nowrap",
    textDecoration: "underline",
  },
})

export const CompareToText = chakra(Text, {
  baseStyle: {
    mt: 0,
    fontSize: "0.625rem",
    lineHeight: "1rem",
  },
})

export const ProductCardContainer = chakra(Flex, {
  baseStyle: {
    flexDirection: "column",
    width: { base: "17.625rem", lg: "24rem" },
    gap: "1.5rem",
    justifyContent: "space-between",
    position: "relative",
    borderBottom: "1px",
    borderColor: colors.border,
    pb: "1rem",
  },
})

export const RibbonText = chakra(Text, {
  baseStyle: {
    mt: 0,
    position: "absolute",
    backgroundColor: colours.accent.medium,
    color: colors.contentTertiary,
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    px: "0.75rem",
    py: "0.125rem",
    alignItems: "center",
    width: "max-content",
  },
})
